import styled from "styled-components";

export const Chunk = styled("span")`
  display: inline-block;
`;
